import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'

const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    }
  ],
  modifiers: ['inverse'],
  states: []
}

const renderPercentage = (value, progress) => {
  const percentage = (value * 100) / progress
  return percentage
}

const renderProgressbar = (value, progress, isVisible) => {
  if (isVisible) {
    const sliderValueBar = renderPercentage(value, progress)
    return (
      <>
        <div
          className="mdn-ProgressBar-percent"
          style={{ left: sliderValueBar.toFixed(2) + '%' }}
        >
          <p className="mdn-ProgressBar-percentText mdn-Heading">
            {sliderValueBar.toFixed(0)}%
          </p>
        </div>
        <progress
          role="progressbar"
          className="mdn-ProgressBar-fill"
          value={value}
          max={progress}
        ></progress>
      </>
    )
  }
}

export default function ProgressBar(props) {
  const { value, isVisible, progress, ...rest } = props
  return (
    <div
      {...rest}
      className={resolveProps(props, config, 'ProgressBar')}
      style={{ visibility: isVisible ? 'visible' : 'hidden' }}
    >
      {renderProgressbar(value, progress, isVisible)}
    </div>
  )
}

ProgressBar.propTypes = {
  value: PropTypes.number,
  progress: PropTypes.number,
  config: PropTypes.object,
  isVisible: PropTypes.bool
}
